import { Injectable } from '@angular/core';
import {Location} from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class HelperService {

  // tslint:disable-next-line:variable-name
  constructor(public _location: Location) { }

  goBack(): void{
    this._location.back();
  }
}
